'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/layout/preferences.hbs');
var Sortable = require('sortable');

var PreferencesLayout = LayoutView.extend({
    template: template,

    className: 'preferences',

    ui: {
        form: 'form',
        selectCurrency: '[name="currency"]',
        selectLengthUnit: '[name="length-unit"]',
        selectWeightUnit: '[name="weight-unit"]',
        updatePreferences: '[type="submit"]',
        sortableList: '.table-columns',
        checkboxes: '[type="checkbox"]',
    },

    events: {
        'submit @ui.form': 'savePreferences',
        'click @ui.checkboxes': 'checkCheckboxes',
    },

    onRender: function(){
        this.sortable = Sortable.create(this.ui.sortableList[0], {
            draggable: 'li',
            handle: '.drag-handle',
            ghostClass: 'drag-placeholder',
            chosenClass: 'drag-active',
            sort: true,
            animation: 150,
        });

        this.renderCurrenciesSelect();
    },

    setSaveable: function() {
        this.ui.updatePreferences.prop('disabled', false);
    },

    savePreferences: function(event){
        event.preventDefault();

        var fieldsEditOrder = [];

        this.ui.sortableList.find('> li > [type="checkbox"]').each(function(index, checkbox) {
            checkbox = $(checkbox);

            var editField = {
                fieldName: checkbox.val(),
                active: checkbox.is(':checked'),
            }

            var subCheckboxes = checkbox.parent().find('> ul [type="checkbox"]');
            var disabledSourceFields = [];
            if (subCheckboxes.length) {
                _.each(subCheckboxes, function(subCheckbox){
                    subCheckbox = $(subCheckbox);
                    if (!subCheckbox.is(':checked')) {
                        disabledSourceFields.push(subCheckbox.val());
                    }
                })

                if (disabledSourceFields.length) {
                    editField.disabledSourceFields = disabledSourceFields.join(',');
                }
            }

            fieldsEditOrder.push(editField);
        });

        this.model.save({
            fieldsEditOrder: fieldsEditOrder,
            userAttributes: {
                defaultCurrency: this.ui.selectCurrency.val(),
                defaultSizeUnit: this.ui.selectLengthUnit.val(), //@todo rename defaultSizeUnit to deafultLengthUnit on backend
                defaultWeightUnit: this.ui.selectWeightUnit.val(),
            },
        }, {
            patch: true,
            success: function() {
                Messenger().post({
                    type: 'success',
                    message: App.t('settings::account:saveSuccess'),
                });

                this.ui.updatePreferences.prop('disabled', false).removeClass('is-loading');
            }.bind(this),
            error: function() {
                Messenger().post({
                    type: 'error',
                    message: App.t('settings::preferences:unknown-save-error'),
                });

                this.ui.updatePreferences.prop('disabled', false).removeClass('is-loading');
            }.bind(this),
        });

        this.ui.updatePreferences.prop('disabled', true).addClass('is-loading');
    },

    /**
     * Renders the selectfield for the currencies
     */
    renderCurrenciesSelect: function() {
        this.renderSelectField({
            holder: this.ui.selectCurrency,
            list: App.radio().request('currencies:collection'),
            key: 'key',
            label: 'name',
            selected: function(data, model) {
                return model.get('key') === App.user.getCurrency();
            }.bind(this),
        });
    },

    checkCheckboxes: function(event) {
        var checkbox = $(event.currentTarget);
        var isMainField = checkbox.closest('li').parent().is('ol');
        var isChecked = checkbox.is(':checked');

        if (isMainField) { //toggle all child checkboxes to the same state as the parent
            var childCheckboxes = checkbox.closest('li').find('ul [type="checkbox"]');
            childCheckboxes.prop('checked', isChecked);
        } else { //toggle the parent checkbox off if last child is unchecked, or on if first child is checked
            var parentCheckbox = checkbox.closest('li').parent().closest('li').find('> [type="checkbox"]');
            var siblingCheckboxes = checkbox.closest('ul').find('[type="checkbox"]');

            parentCheckbox.prop('checked', !!siblingCheckboxes.filter(':checked').length)
        }
    },
});

module.exports = PreferencesLayout;